import * as React from 'react';

import * as CloseCircle from '../../../assets/CloseCircle.svg';
import {Icon, IconState} from '../Icon/Icon';

import * as Styles from './CloseButton.module.scss';

export interface Props {
    disabled?: boolean;
    onClick?: () => void;
    size?: number;
}

export const CloseButton: React.FC<Props> = (props) => {
    const {size = 19, disabled = false, ...rest} = props;
    const state = disabled ? IconState.DISABLED : IconState.DEFAULT;
    return (
        <Icon className={Styles['close']} state={state} {...rest} src={CloseCircle} size={size}/>
    );
};
